import React from "react";
import style from "./CylinderStats.module.scss";

const CylinderStats = ({ stats }) => {
  return (
    <div className={style.cardContainer}>
      {stats?.map(({ name, value, index }) => (
        <div key={name} className={style.card}>
          <p>{value}</p>
          <p>{name}</p>
        </div>
      ))}
    </div>
  );
};

export default CylinderStats;
